import { Child } from "@outschool/gql-backend-generated";
import { LearnerFragmentFragment } from "@outschool/ui-components-classroom";

import {
  ChildInput,
  GetLearnerItems_EnrollmentFragment
} from "../../../../../shared/generated/graphql";

const randString = (): string =>
  Math.random().toString(36).substring(2, 15) +
  Math.random().toString(36).substring(2, 15);

export type LearnerItemType = {
  key: string;
  checked: boolean;
  hasEmptyName?: boolean;
  conflictingEnrollment?: GetLearnerItems_EnrollmentFragment;
  otherSectionEnrollment?: GetLearnerItems_EnrollmentFragment;
  alreadyEnrolled?: boolean;
  prepay?: boolean;
  pendingEnrollment?: boolean;
  alreadyWaitlisted?: boolean;
  hasOverlappingPendingEnrollmentMeetingPurchase?: boolean;
  learner: ChildInput;
  disabled?: boolean;
};

export function defaultLearnerItem(): LearnerItemType {
  return {
    key: randString(),
    checked: true,
    learner: {
      // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
      uid: null,
      name: "",
      age: null,
      date_of_birth: null
    }
  };
}

export function uncheck(learnerItems: LearnerItemType[]): LearnerItemType[] {
  return learnerItems.map(li => (li.checked ? { ...li, checked: false } : li));
}

export type GetLearnerUidsNearAgeRangeParams = {
  learners: Array<
    Partial<Child> | Partial<ChildInput> | Partial<LearnerFragmentFragment>
  >;
  range: [number, number];
};

export type GetLearnerUidsNearAgeRangeResult = {
  learnerUids: Array<string>;
  ageGap: number;
};

export function getLearnerUidsNearAgeRange({
  learners,
  range
}: GetLearnerUidsNearAgeRangeParams): GetLearnerUidsNearAgeRangeResult {
  let minAgeGap = 200;
  let learnerUids: $TSFixMe = [];

  learners.forEach(learner => {
    const { age, uid } = learner;
    if (!age || !uid) {
      return;
    }

    const ageGap = getAgeGapFromRange(age, range);
    if (ageGap === minAgeGap) {
      // @ts-ignore TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
      learnerUids.push(uid);
    }
    if (ageGap < minAgeGap) {
      minAgeGap = ageGap;
      // @ts-ignore TS(2322): Type 'string' is not assignable to type 'never'.
      learnerUids = [uid];
    }
  });

  return {
    ageGap: minAgeGap,
    learnerUids
  };
}

export function getAgeGapFromRange(
  age: number,
  [min, max]: [number, number]
): number {
  if (age >= min && age <= max) {
    return 0;
  }
  return Math.min(Math.abs(age - min), Math.abs(age - max));
}

export function getBuyingLearnerItems(learnerItems: LearnerItemType[]) {
  return learnerItems
    .filter(li => !li.alreadyEnrolled || li.prepay)
    .filter(
      li =>
        !li.pendingEnrollment ||
        !li.hasOverlappingPendingEnrollmentMeetingPurchase
    )
    .filter(li => li.checked)
    .map(li => li.learner);
}
